// extracted by mini-css-extract-plugin
export var externalLink = "_bw-0";
export var internalLinkLabel = "_bw-1";